import { put } from "@redux-saga/core/effects";
import axios from "axios";

import { CreateFormRequestActionType, IForm } from "../types";
import { FormsService, CreateFormResponse } from "../../../services/forms";
import {
    setCurrentForm,
    createFormFailure,
    setFormStyles,
    setInitialFonts,
    initFormButtons,
} from "./../actionCreators";

import { IErrorType } from "./../../types/errors.d";
import { InitPages, updatePageRequest } from "../../pages/actionCreators";
import { formInitials } from "../../../helpers/dataManipulations/initials";
import { initValidationMessages } from "../../validations/actionCreators";
import { validationInitialState } from "../../validations";
import { getDeclarablePaymentData } from "../../../helpers/paymentActions";
import { getDeclarableFormButtonsData } from "../../../helpers/submitButton";
import { completeFormButtonsStyles } from "../../../helpers/dataManipulations";
import { initPaymentData } from "../../payment/actionCreators";

export function* createFormSaga({ payload: { name } }: CreateFormRequestActionType) {
    try {
        const {
            data: { data },
        }: CreateFormResponse = yield FormsService.createForm({ name });

        yield put(
            setCurrentForm({
                _id: data._id,
                name: data.name,
                status: data.status,
                createdAt: data.createdAt,
                updatedAt: data.updatedAt,
            } as IForm),
        );

        yield put(setFormStyles(formInitials.styles));
        yield put(InitPages({ list: data.pages }));

        yield put(updatePageRequest({ _id: data.pages[0]._id, title: "Untitled Page" }));
        yield put(setInitialFonts({ fonts: formInitials.fonts }));
        yield put(initValidationMessages(validationInitialState));
        yield put(initPaymentData(getDeclarablePaymentData()));
        yield put(initFormButtons(getDeclarableFormButtonsData(completeFormButtonsStyles(data.styles.buttons))));
    } catch (error) {
        if (axios.isAxiosError(error))
            yield put(createFormFailure({ errorType: IErrorType.AXIOS, data: error.response?.data }));
        else yield put(createFormFailure({ errorType: IErrorType.NATIVE, data: error }));
    }
}
